export const link = {
  home: "/",
  box: "/box",
  help: "/help",
  news: "/news",
  about: "/about",
  store: "/store",
  logon: "/logon",
  create: "/create",
  address: "/address",
  basicinfo: "/basicinfo",
  redeemprizes: "/redeemprizes",
  redeemhistory: "/redeemhistory",
  points: "/points",
  membership: "/membership",
  remeemsuccess: "/remeemsuccess",
};
